import { mapActions } from 'vuex';
import notificationsList from '@/components/notifications-list/notifications-list.vue';

export default {
  components: {
    notificationsList,
  },
  methods: {
    ...mapActions('notifications', ['closeNotificationsWidget']),
    onClickOutside() {
      this.closeNotificationsWidget();
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/notifications-widget/notifications-widget.js